module.exports = __webpack_public_path__ + "static/media/toycars.de721b3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/toycars.png
// module id = 85
// module chunks = 0